import { render, staticRenderFns } from "./NewsContent.vue?vue&type=template&id=3ac77418&scoped=true"
import script from "./NewsContent.vue?vue&type=script&lang=js"
export * from "./NewsContent.vue?vue&type=script&lang=js"
import style0 from "./NewsContent.vue?vue&type=style&index=0&id=3ac77418&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac77418",
  null
  
)

export default component.exports